/* Only the Couple template loads this guard. The SMART button owns the cart operation. */
(function () {
  var root = document.querySelector('.kg-couple-bundle');
  if (!root || root.dataset.kgCoupleGuard === 'true') return;
  root.dataset.kgCoupleGuard = 'true';
  var timedOut = false;

  function ready() {
    var offers = root.querySelector('smart-widget .sw-offers[role="radiogroup"]');
    if (!offers || !offers.getClientRects().length) return false;
    var appButton = root.querySelector('smart-widget .sw-footer button.sw-btn');
    if (!appButton || !appButton.getClientRects().length) return false;
    // SMART renders one combined color/size variant selector for each sweater.
    var controls = offers.querySelectorAll('.sw-slot-controls.sw-kit-controls select.sw-select');
    return controls.length === 2 && Array.prototype.every.call(controls, function (select) { return !!select.value; });
  }

  function sync() {
    var isReady = ready();
    // Keep the theme form for variant/gallery compatibility, never for purchasing.
    // SMART provides its own button when the native button is unavailable.
    root.querySelectorAll('.product-form__submit').forEach(function (button) {
      if (!button.disabled) button.disabled = true;
    });
    var note = root.querySelector('.kg-couple-loading');
    if (note) {
      if (note.hidden !== isReady) note.hidden = isReady;
      var text = timedOut ? 'Die Couple-Auswahl konnte nicht geladen werden. Bitte lade die Seite neu.' : 'Couple-Auswahl wird geladen …';
      if (!isReady && note.textContent !== text) note.textContent = text;
    }
  }

  function guard(event) {
    var target = event.target;
    var isNativePurchase = event.type === 'submit'
      ? target.matches('product-form form')
      : target.closest('.product-form__submit');
    var isAppPurchase = event.type === 'click' && target.closest('smart-widget .sw-footer button.sw-btn');
    if (!root.contains(target)) return;
    if (!isNativePurchase && (!isAppPurchase || ready())) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync();
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  new MutationObserver(sync).observe(root, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'disabled']
  });
  sync();
  window.setTimeout(function () { timedOut = true; sync(); }, 12000);
})();
